module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"Usuario":"Usuario","Contraseña":"Contraseña","Login":"Login","¿Recuperar contraseña?":"¿Recuperar contraseña?","Cerrar Sesión":"Cerrar Sesión"},"en":{"Usuario":"User","Contraseña":"Password","Login":"Login","¿Recuperar contraseña?":"¿Recover Password?","Cerrar Sesión":"Close session"}}')
  delete Component.options._Ctor
}
